import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthStateService, PlatformService } from '@sml/utility';

@Component({
  selector: 'app-auth-signup',
  template: '',
  standalone: true,
  imports: [CommonModule],
})
export class AuthSignupComponent {
private readonly authState = inject(AuthStateService);
private readonly platformService = inject(PlatformService);

  constructor() {
    if(this.platformService.browser()){
      this.onSignupClick();
    }
  }

  onSignupClick(): void {
    this.authState.auth.loginWithRedirect({
      authorizationParams:{
        screen_hint: 'signup',
      },
      appState: { target: '/callback' }
    });
  }

}
